import React, { useState } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { bindActionCreators } from "redux";
import {
  Tabs,
  Form,
  Input,
  Alert,
  Typography,
  Row,
  Col,
  Image,
  Spin,
} from "antd";

import * as propertyActions from "../../../../actionCreators/Property";
import { useHistory, useParams } from "react-router-dom";
import { fallBackImage } from "../../../../utils/fallbackImage";
import { FormInputField } from "../../../../Components/FormInputField/FormInputField";
import TaxCollectionTabContent from "./TaxCollectionTabContent";
import * as dropDownActions from "../../../../actionCreators/DropDown";
import BasicDetails from "../Properties/BasicDetails";
import LocationDetails from "../Properties/LocationDetails";
import Occupier from "../Properties/Occupier";
import AtvV2 from "../Properties/AtvV2";
import * as changeRequestActions from "../../../../actionCreators/ChangeRequest";

const { REACT_APP_SNG_STORAGE_SERVER_URL } = process.env;

const { TabPane } = Tabs;

const TaxCollectionDetailView = ({
  getCurrentProperty,
  closeViewProperty,
  propertyTypes,
  buildingTypes,
  getBuildingTypes,
  getPropertyTypes,
  getLocalities,
  currentProperty,
}) => {
  const history = useHistory();
  let disabled = true;
  const [propertyData, setPropertyData] = useState();
  const [taxCreatedAt, setTaxCreatedAt] = useState();
  const { id } = useParams();
  React.useEffect(() => {
    getCurrentProperty({ id: id });
  }, [id]);

  React.useEffect(() => {
    setPropertyData(currentProperty.data);
  }, [currentProperty]);
  React.useEffect(() => {
    setTaxCreatedAt(propertyData?.data?.taxes[0]?.created_at);
  }, [propertyData]);
  const [propertyImages, setPropertyImages] = useState(
    propertyData?.data?.documents
  );

  const [buildingType, setBuildingType] = React.useState(
    propertyData?.building_type
  );

  React.useEffect(() => {
    if (propertyData) {
      if (propertyData?.data?.documents) {
        setPropertyImages(propertyData?.data?.documents);
      }
    }
  }, [propertyData]);
  const handleSubmitForm = async (values, actions) => {};
  const closeViewPropertyForm = () => {
    if (history.goBack.length === 0) {
      history.push("/properties/" + propertyData?.data?.status);
    } else {
      history.goBack();
    }
  };
  function callback(key) {}
  const handleBuildingTypeChange = (data) => {
    setBuildingType(data);
  };
  return (
    <React.Fragment>
      {!propertyData ? (
        <div
          style={{
            width: "100%",
            height: "90vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <>
          <div className="header">
            <Typography className="heading">
              <span className="heading-faded">Tax Collection</span> /{" "}
              {propertyData?.data?.pin?.length > 0
                ? propertyData?.data?.pin
                : "--"}
            </Typography>
          </div>
          <div>
            <Formik
              initialValues={{
                with_effect_date: propertyData?.data?.with_effect_date
                  ? moment(propertyData?.data?.with_effect_date).format(
                      "DD MMMM YYYY"
                    )
                  : null,
                district: propertyData?.data?.district?.name,
                locality: propertyData?.data?.locality,
                cnic:
                  propertyData?.data?.property_owners?.length > 0
                    ? propertyData?.data?.property_owners[0]?.cnic
                    : "",
                tehsil: propertyData?.data?.tehsil?.name,
                circle: propertyData?.data?.circle?.name,
                pin: propertyData?.data?.pin,
                street_address: propertyData?.data?.street_address,
                latitude: propertyData?.data?.latitude,
                longitude: propertyData?.data?.longitude,
                property_type: propertyData?.data?.property_type?.name,
                location: propertyData?.data?.location,
                remarks: propertyData?.data?.property_reduction?.remarks,
                property_owners: propertyData?.data?.property_owners,
                occupiers: propertyData?.data?.occupiers,
                inspector:
                  propertyData?.data?.property_inspector?.user?.full_name,
                eto_name: propertyData?.data?.user?.full_name,
                highway_name: propertyData?.data?.highway?.name,
                highway_from: propertyData?.data?.highway_from,
                highway_to: propertyData?.data?.highway_to,
                highway_kms: propertyData?.data?.highway_kms,
                property_number: propertyData?.data?.id,
                khasra_no: propertyData?.data?.khasra_number,
                mouza: propertyData?.data?.mouza?.name,
                locality: propertyData?.data?.locality,
                address: propertyData?.data?.address,
                annual_taxable_value:
                  propertyData?.data?.atv?.annual_taxable_value,
                annual_tax: propertyData?.data?.atv?.annual_tax,
              }}
              validateOnChange={false}
              validateOnBlur={false}
              onSubmit={(values, actions) => handleSubmitForm(values, actions)}
            >
              {(formikProps) => {
                const { errors, isSubmitting, handleSubmit } = formikProps;

                return (
                  <>
                    {Object.keys(errors).length > 0 && (
                      <Alert
                        message={errors.email || errors.password || errors.auth}
                        type="error"
                        showIcon
                        className="column-error"
                      />
                    )}
                    <Form onFinish={handleSubmit} className="widh">
                      <Tabs
                        defaultActiveKey="taxCollection"
                        onChange={callback}
                        className="tab-main"
                      >
                        <TabPane
                          tab="BASIC DETAILS"
                          key="basic"
                          className="tab-pane"
                        >
                          <BasicDetails
                            disabled={disabled}
                            highwayFrom={propertyData.data.highway_from}
                            highwayTo={propertyData.data.highway_to}
                            unregisteredProperty={
                              (propertyData?.data?.submission_type ===
                                "submitted" &&
                                propertyData?.data?.approval_status !==
                                  "approved") ||
                              propertyData?.data?.approval_status === "rejected"
                            }
                            rowData={propertyData.data}
                          />
                        </TabPane>
                        <TabPane
                          tab="LOCATION DETAILS"
                          key="location"
                          className="tab-pane"
                        >
                          <LocationDetails
                            propertyType
                            handlePropertyTypeChange
                            propertyTypes={propertyTypes}
                            Option
                            MapContainer
                            rowData={propertyData?.data}
                            disabled={disabled}
                          />
                        </TabPane>
                        <TabPane
                          tab="OWNERSHIP"
                          key="ownership"
                          className="tab-pane"
                        >
                          <Tabs tabPosition="left" className="tab-side">
                            {propertyData?.data?.property_owners?.map(
                              (owner, index) => {
                                return (
                                  <TabPane tab={owner.name} key={index}>
                                    <Row>
                                      <Col span={12} className="column-left">
                                        <Field
                                          InputType={Input}
                                          component={FormInputField}
                                          labelText="Name"
                                          name={`property_owners[${index}].name`}
                                          hideErrorMessage={true}
                                          className="text-field"
                                          disabled={disabled}
                                        />
                                      </Col>
                                      <Col span={12} className="column-right">
                                        <Field
                                          InputType={Input}
                                          component={FormInputField}
                                          labelText="CNIC"
                                          name={`property_owners[${index}].cnic`}
                                          hideErrorMessage={true}
                                          className="text-field"
                                          disabled={disabled}
                                          value={
                                            propertyData?.data?.property_owners[
                                              index
                                            ].cnic === null && "-"
                                          }
                                          placeholder={"—"}
                                        />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={12} className="column-left">
                                        <Field
                                          InputType={Input}
                                          component={FormInputField}
                                          labelText="Father/Husband Name"
                                          name={`property_owners[${index}].father_name`}
                                          hideErrorMessage={true}
                                          className="text-field"
                                          disabled={disabled}
                                          value={
                                            propertyData?.data?.property_owners[
                                              index
                                            ].father_name === null && "-"
                                          }
                                          placeholder={"—"}
                                        />
                                      </Col>
                                      <Col span={12} className="column-right">
                                        <Field
                                          InputType={Input}
                                          component={FormInputField}
                                          name={`property_owners[${index}].email`}
                                          labelText="Email"
                                          hideErrorMessage={true}
                                          className="text-field"
                                          disabled={disabled}
                                          value={
                                            propertyData?.data?.property_owners[
                                              index
                                            ].email === null && "-"
                                          }
                                          placeholder={"—"}
                                        />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={12} className="column-left">
                                        <Field
                                          InputType={Input}
                                          component={FormInputField}
                                          name={`property_owners[${index}].phone_number`}
                                          labelText="Cell No"
                                          hideErrorMessage={true}
                                          className="text-field"
                                          disabled={disabled}
                                          value={
                                            propertyData?.data?.property_owners[
                                              index
                                            ].phone_number === null && "-"
                                          }
                                          placeholder={"—"}
                                        />
                                      </Col>
                                      <Col span={12} className="column-right">
                                        <Field
                                          InputType={Input}
                                          component={FormInputField}
                                          name={`property_owners[${index}].shares`}
                                          labelText="Share %"
                                          hideErrorMessage={true}
                                          className="text-field"
                                          disabled={disabled}
                                          value={
                                            (propertyData?.data
                                              ?.property_owners[index]
                                              .shares === "" ||
                                              propertyData?.data
                                                ?.property_owners[index]
                                                .shares === null ||
                                              propertyData?.data
                                                ?.property_owners[index]
                                                .shares === undefined ||
                                              propertyData?.data
                                                ?.property_owners[index]
                                                .shares === 0) &&
                                            "-"
                                          }
                                          placeholder={"—"}
                                        />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={12} className="column-left">
                                        <b>Document Proof</b>
                                      </Col>
                                    </Row>
                                    {owner.documents &&
                                      owner.documents.map((image) => {
                                        return (
                                          <div className="image-parser">
                                            <Image
                                              width={200}
                                              height={200}
                                              className="image"
                                              src={`${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`}
                                              // fallback={fallBackImage}
                                            />
                                            <span
                                              style={{
                                                position: "absolute",
                                                bottom: 0,
                                                width: "100%",
                                                backgroundColor: "#34343438",
                                                fontWeight: 600,
                                                color: "white",
                                                textAlign: "center",
                                              }}
                                            >
                                              {moment(image.created_at).format(
                                                "DD-MM-YYYY  hh:mm"
                                              )}
                                            </span>
                                          </div>
                                        );
                                      })}
                                    <Row>
                                      {(!owner.documents ||
                                        owner.documents.length == 0) && (
                                        <span>No proof attached</span>
                                      )}
                                    </Row>
                                  </TabPane>
                                );
                              }
                            )}
                          </Tabs>
                        </TabPane>
                        <TabPane
                          tab="OCCUPIER"
                          key="occupier"
                          className="tab-pane"
                        >
                          <Occupier
                            rowData={propertyData?.data}
                            buildingType={buildingType}
                            buildingTypes={buildingTypes}
                            handleBuildingTypeChange={handleBuildingTypeChange}
                            disabled={disabled}
                          />
                        </TabPane>
                        <TabPane tab="ATV" key="atv" className="tab-pane">
                          <AtvV2
                            disabled={disabled}
                            atvData={propertyData?.data?.atv}
                          />
                        </TabPane>
                        <TabPane tab="IMAGES" key="images" className="tab-pane">
                          {propertyImages &&
                            propertyImages.map((image) => {
                              return (
                                <div className="image-parser">
                                  <Image
                                    width={200}
                                    height={200}
                                    className="image"
                                    src={`${REACT_APP_SNG_STORAGE_SERVER_URL}${image.path}`}
                                    fallback={fallBackImage}
                                  />
                                  <span
                                    style={{
                                      position: "absolute",
                                      bottom: 0,
                                      width: "100%",
                                      backgroundColor: "#34343438",
                                      fontWeight: 600,
                                      color: "white",
                                      textAlign: "center",
                                    }}
                                  >
                                    {moment(image.created_at).format(
                                      "DD-MM-YYYY  hh:mm"
                                    )}
                                  </span>
                                </div>
                              );
                            })}
                          {(!propertyImages || propertyImages?.length == 0) && (
                            <span>No property images were added</span>
                          )}
                        </TabPane>
                        <TabPane
                          tab="TAX COLLECTION"
                          key="taxCollection"
                          className="tab-pane"
                        >
                          <TaxCollectionTabContent
                            propertyId={id}
                            propertyData={propertyData?.data}
                            taxCreatedAt={taxCreatedAt}
                          />
                        </TabPane>
                      </Tabs>
                    </Form>
                  </>
                );
              }}
            </Formik>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = ({
  property: { currentProperty },
  dropDown: { propertyTypes, buildingTypes, localities, localityCodes, blocks },
}) => ({
  propertyTypes,
  buildingTypes,
  localities,
  localityCodes,
  blocks,
  currentProperty,
});

const mapDispatchToProps = (dispatch) => ({
  getBuildingTypes: bindActionCreators(
    dropDownActions.getBuildingTypes,
    dispatch
  ),
  getPropertyTypes: bindActionCreators(
    dropDownActions.getPropertyTypes,
    dispatch
  ),
  getLocalities: bindActionCreators(dropDownActions.getLocalities, dispatch),
  getLocalityCodes: bindActionCreators(
    dropDownActions.getLocalityCodes,
    dispatch
  ),
  getBlocks: bindActionCreators(dropDownActions.getBlocks, dispatch),
  getCurrentProperty: bindActionCreators(
    propertyActions.getCurrentProperty,
    dispatch
  ),
  setPropertyApproval: bindActionCreators(
    propertyActions.setPropertyApproval,
    dispatch
  ),
  updateChangeRequest: bindActionCreators(
    changeRequestActions.updateChangeRequest,
    dispatch
  ),
});

TaxCollectionDetailView.propTypes = {
  getPropertyTypes: PropTypes.func.isRequired,
  getBuildingTypes: PropTypes.func.isRequired,
  propertyTypes: PropTypes.array.isRequired,
  buildingTypes: PropTypes.array.isRequired,
  setPropertyApproval: PropTypes.func.isRequired,
  closeViewProperty: PropTypes.func.isRequired,
  getLocalities: PropTypes.func.isRequired,
  getLocalityCodes: PropTypes.func.isRequired,
  getWards: PropTypes.func.isRequired,
  getBlocks: PropTypes.func.isRequired,
  localities: PropTypes.object.isRequired,
  localityCodes: PropTypes.object.isRequired,
  wards: PropTypes.object.isRequired,
  blocks: PropTypes.object.isRequired,
  getCurrentProperty: PropTypes.func.isRequired,
  currentProperty: PropTypes.object.isRequired,
  updateChangeRequest: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaxCollectionDetailView);
